import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
export const creditorCreate = async (body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorCreate), {
        credentials: "include",
        headers,
        json: {
            creditors: body,
        },
    }).json();
};
export const creditorList = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.CreditorList), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const creditorSelf = async (creditorId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.CreditorSelf, { creditorId }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const creditorUpdate = async (creditorId, body, _queryParams, headers) => {
    return api.API.put(getEndpointURL(Endpoint.CreditorUpdate, { creditorId }), {
        credentials: "include",
        headers,
        json: {
            creditors: body,
        },
    }).json();
};
export const creditorCloseAccount = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorCloseAccount, { creditorId }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const creditorChangeFlexiblePayoutSettings = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorChangeFlexiblePayoutSettings, {
        creditorId,
    }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const creditorRequestFlexiblePayoutOverride = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorRequestFlexiblePayoutOverride, {
        creditorId,
    }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const creditorClearFlexiblePayoutOverride = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorClearFlexiblePayoutOverride, {
        creditorId,
    }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const creditorUpdateHoldingPeriod = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorUpdateHoldingPeriod, { creditorId }), {
        credentials: "include",
        headers,
        json: {
            creditors: body,
        },
    }).json();
};
export const creditorUpdateMerchantCategoryCode = async (creditorId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.CreditorUpdateMerchantCategoryCode, { creditorId }), {
        credentials: "include",
        headers,
        json: {
            creditors: body,
        },
    }).json();
};
